
import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { setupUnloadTracking } from '@/utils/sessionTracker';

const SessionManager = () => {
  const { user } = useAuth();

  useEffect(() => {
    // Only setup unload tracking when user is logged in
    if (!user) return;

    // Setup unload tracking and get cleanup function
    const cleanupUnloadTracking = setupUnloadTracking();
    
    // Cleanup on component unmount
    return () => {
      cleanupUnloadTracking();
    };
  }, [user]);

  // This component doesn't render anything
  return null;
};

export default SessionManager;
